export class CustomError extends Error {}

export class AppInitializationError extends CustomError {}

export class RoomError extends CustomError {}
